exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}:focus{outline:none}body{overflow-x:hidden;min-height:100vh;width:100%;background-color:var(--bg-color);color:var(--font-color);scrollbar-width:0!important;font-family:yekan,lato;transition:all .3s!important}li,ul{list-style:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/style/main.scss
// module id = 490
// module chunks = 0